import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../dto/data-model.js';
import { MarketingVendorSettings } from './marketing-vendor-settings.js';
import { MarketingVendorType } from './marketing-vendor-type.js';

export class MailchimpSettings extends MarketingVendorSettings {
  static readonly TYPE_ID: string = '054a681b192b4caea4399f6c1ead596e';

  private constructor(
    public readonly apiKey: string,
    public readonly serverId: string,
    public readonly listId: string,
  ) {
    super();
  }

  get $typeId(): string {
    return MailchimpSettings.TYPE_ID;
  }

  get type(): MarketingVendorType {
    return MarketingVendorType.Mailchimp;
  }

  static create(args: {
    apiKey: string,
    serverId: string,
    listId: string,
  }): MailchimpSettings {
    return new MailchimpSettings(
        args.apiKey,
        args.serverId,
        args.listId,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): MailchimpSettings {
    return this.create({
      apiKey: MapUtils.getString(map, 'apiKey'),
      serverId: MapUtils.getString(map, 'serverId'),
      listId: MapUtils.getString(map, 'listId'),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      type: fromEnumAsString(this.type),
      apiKey: this.apiKey,
      serverId: this.serverId,
      listId: this.listId,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    apiKey = this.apiKey,
    serverId = this.serverId,
    listId = this.listId,
  }: {
    apiKey?: string,
    serverId?: string,
    listId?: string,
  } = {}): this {
    return MailchimpSettings.create({
      apiKey,
      serverId,
      listId,
    }) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.apiKey === this.apiKey &&
        other.serverId === this.serverId &&
        other.listId === this.listId;
  }
}

export class MailchimpSettingsBuilder extends DataModelBuilder<MailchimpSettings> {
  build(context: SerializationContext, map: SerializedData): MailchimpSettings {
    return MailchimpSettings.fromMap(context, map);
  }
}
